import PropTypes from 'prop-types';
import React, { useContext, useReducer } from 'react';

const UIContext = React.createContext({
  state: {
    menuOpen: false,
    searchOpen: false,
    notificationsDropdownOpen: false,
    accountHubOpen: false,
  },
  dispatch: null,
});

const useUI = () => useContext(UIContext);

export const TYPE_OPEN_MENU = 'openMenu';
export const TYPE_CLOSE_MENU = 'closeMenu';
export const TYPE_TOGGLE_MENU = 'toggleMenu';
export const TYPE_OPEN_SEARCH = 'openSearch';
export const TYPE_CLOSE_SEARCH = 'closeSearch';
export const TYPE_TOGGLE_SEARCH = 'toggleSearch';
export const TYPE_TOGGLE_NOTIFICATIONS_DROPDOWN = 'toggleNotificationsDropdown';
export const TYPE_TOGGLE_ACCOUNT_HUB = 'toggleAccountHub';

const reducer = (state, action) => {
  switch (action.type) {
    case TYPE_OPEN_MENU:
      return {
        ...state,
        menuOpen: true,
        searchOpen: false,
        notificationsDropdownOpen: false,
        accountHubOpen: false,
      };
    case TYPE_CLOSE_MENU:
      return {
        ...state,
        menuOpen: false,
        notificationsDropdownOpen: false,
        accountHubOpen: false,
      };
    case TYPE_TOGGLE_MENU:
      return {
        ...state,
        menuOpen: !state.menuOpen,
        searchOpen: false,
        notificationsDropdownOpen: false,
        accountHubOpen: false,
      };
    case TYPE_OPEN_SEARCH:
      return {
        ...state,
        searchOpen: true,
        menuOpen: false,
        notificationsDropdownOpen: false,
        accountHubOpen: false,
      };
    case TYPE_CLOSE_SEARCH:
      return { ...state, searchOpen: false };
    case TYPE_TOGGLE_SEARCH:
      return {
        ...state,
        searchOpen: !state.searchOpen,
        menuOpen: false,
        notificationsDropdownOpen: false,
        accountHubOpen: false,
      };
    case TYPE_TOGGLE_NOTIFICATIONS_DROPDOWN:
      return {
        ...state,
        notificationsDropdownOpen: !state.notificationsDropdownOpen,
        menuOpen: false,
        accountHubOpen: false,
        searchOpen: false,
      };
    case TYPE_TOGGLE_ACCOUNT_HUB:
      return {
        ...state,
        accountHubOpen: !state.accountHubOpen,
        menuOpen: false,
        notificationsDropdownOpen: false,
      };
    default:
      throw new Error();
  }
};

const initialState = {
  menuOpen: false,
  searchOpen: false,
  notificationsDropdownOpen: false,
  accountHubOpen: false,
};

export const UIContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <UIContext.Provider value={{ state, dispatch }}>
      {children}
    </UIContext.Provider>
  );
};

UIContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default useUI;
